import { Component, ViewEncapsulation, Inject, PLATFORM_ID } from '@angular/core';
import { ComponentModalBase } from '@framework/base/component';
import { UntypedFormGroup, UntypedFormBuilder, Validators } from '@angular/forms';
import * as _ from 'lodash';
import { BehaviorSubject, Observable, Subscription } from 'rxjs';
import { UploaderConfig, Callback } from '@framework/models';
import { Router } from '@angular/router';
import { environment } from '@app/env/environment';
import { debounceTime, retry } from 'rxjs/operators';
import { RssFeedHttpService } from '@modules/company/services/rss-feed.http-service';
import { ToastService, UploaderService, ModalService } from '@framework/services';
import { ofType, Actions } from '@ngrx/effects';
import { storyActions } from '@modules/story/store/actions';
import { Store } from '@ngrx/store';
import { CoreState } from '@app/store/core/states';
import { AuthService } from '@framework/services';
import * as adminStoryActions from '@modules/company-admin/store/actions';
import { CreateMediaInputApiModel } from '@app/store/http/models/input';
import * as filestack from 'filestack-js';
import { UtilityHelper } from '@framework/utilities';
import { UpdateTestimonialAudienceSettingInputApiModel } from '@modules/company-admin/store/models/api-models/input';
import { HttpClient } from '@angular/common/http';
import { CompanyViewModel } from '@modules/company/models/store-view-models';
import { isPlatformBrowser } from '@angular/common';
import { CropImageModalComponent } from '../crop-image-modal/crop-image-modal.component';
import { CropImageInitData } from '@modules/shared/models/common';
import { ImageCropperConfig } from '../image-cropper/models';

import { companySelectors } from '@modules/company/store/selectors';

@Component({
  selector: 'edit-guest-labels',
  templateUrl: './edit-guest-operation.component.html',
  styleUrls: ['./edit-guest-operation.component.scss'],
})

export class EditGuestLabelsComponent extends ComponentModalBase<any> {

  public copyForm: UntypedFormGroup;
  public userForm: UntypedFormGroup;
  public author_id:any;
  public story_details?:any;
  public show_toggle:boolean = false;
  public testimonoialData:any = [];
  private addSuccessSubscription: Subscription;
  private updateSuccessSubscription: Subscription;
  private addFailureSubscription: Subscription;
  private AddSucessSubscription: Subscription;
  public primary_color:any;
  public toggleColor:any;
  public hideVisiblity:boolean = true;
  public lableAddDetails:any;
  private updateFailureSubscription: Subscription;
  private loadDetailSuccess: Subscription;
  public currentCompany: CompanyViewModel;
  private LoadAudienceAction: Subscription;
  public disabled:boolean = false
  public authorDataRelationShip:any;
  private loadColorSuccessSubscription: Subscription;
  public showError:any;
  public consent_details:any;
  public template:any;
  public signatureImg:any;
  public nameOfData:any;
  private uploader: any;
  public primaryColor:any;
  public showLoader:boolean = false;
  public relationshipStatus:any;
  public isUpdating: boolean = false;
  public uploadedUrl: any;
  public show_display_button:boolean = false;
  public apiCollection:any;
  // private selectCompanySubscription: Subscription;
    // private selectCompany$: Observable<CompanyViewModel>;
  public uploaderViewModel: any = {
    errorMsg: 'An error occurred while uploading.',
    isError: false,
    progress: 0,
    progressCss: '0%',
    isUploading: false
  };
  public isBrowser: boolean;
  enable_labels: any;

  constructor(
    private formBuilder: UntypedFormBuilder,
    private router: Router,
    private actions$: Actions,
    private utility: UtilityHelper,
    private store$: Store<CoreState>,
    private http: HttpClient,
    private uploaderService: UploaderService,
    private toastService: ToastService,
    private authService: AuthService,
    private rssFeedHttpService: RssFeedHttpService,
    private modalService: ModalService,
     @Inject(PLATFORM_ID) platformId: Object,
  ) {
    super();
    this.initForm();
  this.isBrowser = isPlatformBrowser(platformId);

      // this.selectCompany$ = this.store$.select(companySelectors.selectSelectedCompany);
  }

  // Life cycle hook
  protected onInit(): void {

    this.copyForm.controls.is_alias.valueChanges.subscribe((res) => {
      if (!res) {
        this.copyForm.controls.show_name_public.setValue(true, { emitEvent: false });
      }
      else{
        this.copyForm.controls.show_name_public.setValue(false, { emitEvent: false });
      }
    });
    
    this.userForm.controls.is_alias.valueChanges.subscribe((res) => {
      if (!res) {
        this.userForm.controls.show_name_public.setValue(true, { emitEvent: false });
      }
      else{
        this.userForm.controls.show_name_public.setValue(false, { emitEvent: false });
      }
    });
    
    this.copyForm.controls.show_name_public.valueChanges.subscribe((res) => {
      if (!res) {
        this.copyForm.controls.is_alias.setValue(true, { emitEvent: false });
      }
      else{
        this.copyForm.controls.is_alias.setValue(false, { emitEvent: false });
      }
    });
    

    this.userForm.controls.show_name_public.valueChanges.subscribe((res) => {
      if (!res) {
        this.userForm.controls.is_alias.setValue(true, { emitEvent: false });
      }
      else{
        this.userForm.controls.is_alias.setValue(false, { emitEvent: false });
      }
    });
    
    // this.embedForm.valueChanges.pipe(debounceTime(500)).subscribe(() => {
    //   this.showPreview = false;
    //   this.loadScript();
    // })

    // this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Load(this.initialState.companyId));
    setTimeout(()=>{
this.initUploader();
    },1000)
    this.store$.dispatch(new storyActions.LoadDetail(this.initialState.storyId));
    this.store$.dispatch(new adminStoryActions.storyActions.GetColor(this.initialState?.companyId));

    this.addSuccessSubscription = this.actions$.pipe(
      ofType<adminStoryActions.testimonialAudienceSettingActions.AddSuccess>(adminStoryActions.testimonialAudienceSettingActions.ActionTypes.ADD_SUCCESS)
    ).subscribe((action) => {
      if(action.response?.id){
        //console.log(action.response )
        let obj = {id:action.response?.id,name:action.response?.name}
      this.testimonoialData.push(obj)
      if(this.initialState?.inbound){
        this.copyForm.controls.selctedId.setValue(action.response?.id);
      }
      else{
        this.userForm.controls.selctedId.setValue(action.response?.id);
      }


      }

    });

    this.addFailureSubscription = this.actions$.pipe(
      ofType<adminStoryActions.testimonialAudienceSettingActions.AddFailure>(adminStoryActions.testimonialAudienceSettingActions.ActionTypes.ADD_FAIL)
    ).subscribe(() => {
      this.isUpdating = false;
    });



    this.updateSuccessSubscription = this.actions$.pipe(
      ofType<adminStoryActions.testimonialAudienceSettingActions.UpdateSuccess>(adminStoryActions.testimonialAudienceSettingActions.ActionTypes.UPDATE_SUCCESS)
    ).subscribe(() => {
      this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Load(this.initialState.companyId));
      this.isUpdating = false;
      this.onClose.emit(true);
    });

    this.updateFailureSubscription = this.actions$.pipe(
      ofType<adminStoryActions.testimonialAudienceSettingActions.UpdateFailure>(adminStoryActions.testimonialAudienceSettingActions.ActionTypes.UPDATE_FAIL)
    ).subscribe(() => {
      this.isUpdating = false;
    });
    this.loadDetailSuccess = this.actions$.pipe(
      ofType<storyActions.LoadDetailSuccess>(storyActions.ActionTypes.LOAD_DETAIL_SUCCESS)
    ).subscribe(action => {
     
      if(action && action?.data){
        this.story_details = action?.data;
        //console.log(">>Cosnole",this.story_details)
        if(this.initialState?.inbound || this.initialState?.consent){
          this.consent_details = action?.data?.consent_details?.esignature ? action?.data?.consent_details : null;
          this.author_id = action?.data?.author?.author_id
           this.copyForm.patchValue({
             companyname:action?.data?.author?.company_name,
             title:action?.data?.title_alias ? action?.data?.title_alias : "",
             name: action?.data?.author?.display_name,
             author_alias: action?.data?.author_alias,
             is_alias:action?.data?.is_alias,
             show_prompt:action?.data?.show_prompt,
           }, {emitEvent: false})
   
           if(this.initialState.inbound){
             this.copyForm.patchValue({
               allowrelationsshipPublic:action?.data?.is_relationship_public,
               allowShowTitle:action?.data?.is_title_public,
               allowShowName:action?.data?.is_name_public,
               allowShowComapnyName:action?.data?.is_company_public,
               show_relationship_public:action?.data?.show_relationship_public,
               show_company_public:action?.data?.show_company_public,
               show_name_public:action?.data?.show_name_public,
               show_title_public:action?.data?.show_title_public
             },{emitEvent: false})
         
                 this.changeActionEvent(null);
   
           }
           else{
             this.copyForm.controls.Label.enable();
           }
   
   
   
           if(!this.initialState.campaignId || this.initialState.campaignId == null ||  this.initialState.campaignId.toString() == '-1' ){
             this.show_toggle = true;
           }
           else{
             this.checkCampaign();
           }

           if(action?.data?.photo_alias){
            this.copyForm.controls.avatarImage.setValue(action?.data?.photo_alias);
          }
          // else if(action?.data?.author?.avatar){
          //  this.copyForm.controls.avatarImage.setValue(action?.data?.author?.avatar);
          // }
   
          //  if(action?.data?.author?.avatar){
          //    this.copyForm.controls.avatarImage.setValue(action?.data?.author?.avatar);
          //  }
           this.authorDataRelationShip = action?.data?.author?.relationship ? action?.data?.author?.relationship.toLowerCase() : null
           this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Load(this.initialState.companyId));
        }
        else{
          this.author_id = action?.data?.author?.author_id
             this.userForm.patchValue({
              title:action?.data?.title_alias ? action?.data?.title_alias : "",
              name: action?.data?.author?.display_name,
              author_alias: action?.data?.author_alias,
              show_prompt:action?.data?.show_prompt,
              show_name_public:action?.data?.show_name_public,
              show_relationship_public:action?.data?.show_relationship_public,
              show_title_public:action?.data?.show_title_public,
              is_alias:action?.data?.is_alias,
              show_company_public:action?.data?.show_company_public,
              companyname:action?.data?.author?.company_name,
             }, {emitEvent: false})
             this.userForm.controls.Label.enable();
  
   
           if(!this.initialState.campaignId || this.initialState.campaignId == null ||  this.initialState.campaignId.toString() == '-1' ){
             this.show_toggle = true;
           }
           else{
             this.checkCampaign();
           }
   
           if(action?.data?.photo_alias){
             this.userForm.controls.avatarImage.setValue(action?.data?.photo_alias);
           }
          //  else if(action?.data?.author?.avatar){
          //   this.userForm.controls.avatarImage.setValue(action?.data?.author?.avatar);
          //  }
           this.authorDataRelationShip = action?.data?.author?.relationship ? action?.data?.author?.relationship.toLowerCase() : null
           this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Load(this.initialState.companyId));
        }

        setTimeout(()=>{
          this.show_display_button = true;
        },1000)
         
                // this.showLoader = false;
      }
      else{
        // this.showLoader = false;
        this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Load(this.initialState.companyId));
      }


    })

    this.loadColorSuccessSubscription = this.actions$.pipe(
      ofType<adminStoryActions.storyActions.GetColorSuccess>(adminStoryActions.storyActions.ActionTypes.GET_BUTTON_COLOR_SUCCESS)
    ).subscribe((action: any) => {
      if(action && action.response && action.response && action.response.length){
        this.primary_color = action.response.find(item => item.button == 11).color;
        this.toggleColor = action.response.find(item => item.button == 4).color
        // this.boxshadowcolr = '0 -0.1875rem 0'+action.response.find(item => item.button == 6).color+'inset;'
       }
      

    })

 
    // this.selectCompanySubscription = this.selectCompany$.subscribe((company) => {
    //   if (company) { this.currentCompany = company; 
    //     this.enable_labels = this.currentCompany?.enable_labels
    //      //this.loadCampaigns(); 
  
    //     }
    // });


    this.LoadAudienceAction = this.actions$.pipe(
      ofType<adminStoryActions.testimonialAudienceSettingActions.LoadSuccess>(adminStoryActions.testimonialAudienceSettingActions.ActionTypes.LOAD_SUCCESS)
    ).subscribe((action:any) => {
if(action){
  if(action.response){
  this.testimonoialData = action.response;
  this.nameOfData = action.response.map(item => item.name.toLowerCase())
  const nonCampaign = {
    "id": '',
    "name": "Select",
    "is_active": true
}

if(this.testimonoialData && this.testimonoialData.length){
  this.testimonoialData.unshift(nonCampaign)
}
  
  // this.store$.dispatch(new storyActions.LoadDetail(this.initialState.storyId));
  if(this.authorDataRelationShip){
    let data = this.testimonoialData.find(item => item.name.toLowerCase() == this.authorDataRelationShip)
    if(data){
      if(this.initialState?.inbound){
        this.copyForm.controls.selctedId.setValue(data?.id)
      }
      else{
        this.userForm.controls.selctedId.setValue(data?.id);
      }
    }
  }
  }


 
}
    });

  }
  protected onDestroy(): void {
    this.addSuccessSubscription.unsubscribe();
    this.LoadAudienceAction.unsubscribe();

    this.updateSuccessSubscription.unsubscribe();
    this.addFailureSubscription.unsubscribe();
    this.updateFailureSubscription.unsubscribe()

    if(this.loadDetailSuccess){
      this.loadDetailSuccess.unsubscribe();
    }
  }
  protected onChanges(): void {

  }
  protected onDoCheck(): void {

  }
  protected onAfterContentInit(): void {

  }
  protected onAfterContentChecked(): void {

  }
  protected onAfterViewInit(): void {
    // this.loadScript();
    if(this.isBrowser) {
      this.uploadData();
    }
  }
  protected onAfterViewChecked(): void {

  }

  private initForm() {

    this.copyForm = this.formBuilder.group({
      selctedId:[''],
      companyname:[{ value: '', disabled: true }],
      show_prompt:[true],
      is_alias:[],
      showname:[false],
      show_relationship_public:[false],
      show_company_public:[false],
      show_name_public:[false],
      show_title_public:[false],
      title:[{ value: '', disabled: true }],
      name:[{ value: '', disabled: true}],
      author_alias:[],
      avatarMedia: [],
      avatarImage: [],
      allowShowTitle:[false],
      allowShowName:[false],
      allowShowComapnyName:[false],
      allowrelationsshipPublic:[false],
      Label:[{value: '', disabled: true }]

    })

    this.userForm = this.formBuilder.group({
      selctedId:[''],
      show_prompt:[true],
      title:[],
      name:[{ value: '', disabled: true}],
      author_alias:[],
      is_alias:[],
      companyname:[{ value: '', disabled: true }],
      show_name_public:[true],
      show_relationship_public:[true],
      show_title_public:[true],
      show_company_public:[true],
      avatarMedia: [],
      avatarImage: [],
      Label:[{value: '', disabled: true }]

    })
  }

  public checkCampaign(){
    let serviceUrl = `${environment.endpointUrl}${'/companies'}`;
    this.http.get(`${serviceUrl}/${this.initialState.companyId}/campaigns/${this.initialState.campaignId}/`, {
      headers: { 'Cache-Control': 'no-cache, no-store', 'Pragma': 'no-cache' },
      params: { timestamp: Date.now().toString() }
    }).subscribe((campaign:any) => {
      if(campaign){
        if(campaign && campaign?.show_story_prompt ){
           this.show_toggle = true; 
        }
        else{
          this.show_toggle = false; 
        }
      }

    })
  }
  private initUploader() {
    let config = new UploaderConfig();
    // config.button = this.browseFileButton.toArray()[0].nativeElement;
    config.companyId = this.initialState.companyId;
    config.isAnonymous = this.initialState.inbound;
    config.validate = {
      allowedExtensions: [
        'jpg', 'jpeg', 'png', 'gif', 'webp', 'svg', 'bmp', 'ico', 'tif', 'tiff', 'heic', 'heif', 'avif'
      ]
    };
    config.messages = {
      imageDimensionError: 'Use a larger image - 640 x 480px minimum.',
      typeError: 'Acceptable file formats are gif, jpg, jpeg, png, mp4, mpg and mov.'
    };

    let callbacks = new Callback();
    callbacks.onSubmit = this.onUploaderSubmit.bind(this);
    callbacks.onComplete = this.onUploaderComplete.bind(this);
    callbacks.onError = this.onUploaderError.bind(this);
    callbacks.onProgress = this.onProgress.bind(this);
    // callbacks.onAllComplete = this.onUploaderAllComplete.bind(this);

    this.uploader = this.uploaderService.s3Uploader(config, callbacks);
  }

  private onUploaderProgress(id: any, name: any, loaded: any, total: any) {
    const percent = Math.round((loaded / total) * 100);
  }

  

    private onProgress(id, name, loaded, total) {
    const percent = (loaded / total) * 100;
    this.uploaderViewModel.progress = percent;
    this.uploaderViewModel.progressCss = `${percent}%`;
  }

  private onUploaderSubmit(id, fileName) {
    this.uploaderViewModel.progress = 0;
    this.uploaderViewModel.progressCss = '0%';
    this.uploaderViewModel.isUploading = true;
    this.uploaderViewModel.isError = false;
  }

  private onUploaderComplete(id, name, responseJSON, maybeXhr) {
    this.uploaderViewModel.isUploading = false;

    if (responseJSON.success) {
      let createMediaInputData = new CreateMediaInputApiModel();
      createMediaInputData.origname = name;
      createMediaInputData.size = this.uploader.getSize(id);
      const fileInfo = this.uploaderService.getUploadedFile(id);
      createMediaInputData.path = fileInfo.path;
      createMediaInputData.source = fileInfo.name;
      createMediaInputData.filename = fileInfo.name;
      createMediaInputData.type = fileInfo.type;

      if(this.initialState.inbound){
        this.copyForm.controls.avatarMedia.setValue(createMediaInputData)
        this.copyForm.controls.avatarImage.setValue('https://images.goodseeker.com/goodseeker'+fileInfo.path+'/'+fileInfo.name+'?tr=n-stories_list')
      }
      else{
        this.userForm.controls.avatarMedia.setValue(createMediaInputData)
        this.userForm.controls.avatarImage.setValue('https://images.goodseeker.com/goodseeker'+fileInfo.path+'/'+fileInfo.name+'?tr=n-stories_list')
      }



    }
  }

  private onUploaderError(id, name, reason, maybeXhrOrXdr) {
    this.uploaderViewModel.isError = true;
    this.uploaderViewModel.errorMsg = reason;
  }

  addTracking(){

  }

  changeData(data){

  }


  close(){
    this.onClose.emit(false)
  }

  save(){
   let obj:any = {}
   if(this.initialState.inbound){
    if(this.copyForm.controls.avatarMedia.value){
      obj.created_by={
        id_user: this.author_id, 'company_name': this.copyForm.controls.companyname.value,
        show_relationship_public: this.copyForm.controls.show_relationship_public.value,
        show_company_public:this.copyForm.controls.show_company_public.value,
        show_name_public:this.copyForm.controls.show_name_public.value,
        is_alias:this.copyForm.controls.is_alias.value,
        show_title_public:this.copyForm.controls.show_title_public.value }
        obj.photo_alias  = this.copyForm.controls.avatarImage.value;
    }
    if(!this.copyForm.controls.avatarMedia.value){
      obj.created_by={
        id_user: this.author_id, 'company_name': this.copyForm.controls.companyname.value,show_relationship_public: this.copyForm.controls.show_relationship_public.value,
        show_company_public:this.copyForm.controls.show_company_public.value,
        is_alias:this.copyForm.controls.is_alias.value,
        show_name_public:this.copyForm.controls.show_name_public.value,
        show_title_public:this.copyForm.controls.show_title_public.value }
    }


    if(this.copyForm.controls.selctedId.value){
     obj.questionnaire = {0: this.copyForm.controls.selctedId.value.toString()}
    }
    else if(!this.copyForm.controls.selctedId.value){
      obj.questionnaire = {0: ''}
    }
    obj.show_prompt = this.copyForm.controls.show_prompt.value ? 1 : 0
    obj.company_id = this.initialState.companyId
    obj.author_alias=this.copyForm.controls.author_alias.value;
    obj.title_alias =this.copyForm.controls.title.value;
   }
   else{
    if(this.copyForm.controls.selctedId.value){
     obj.questionnaire = {0: this.copyForm.controls.selctedId.value.toString()}
    }
    else if(!this.copyForm.controls.selctedId.value){
      obj.questionnaire = {0: ''}
   }
    obj.show_prompt = this.copyForm.controls.show_prompt.value ? 1 : 0
    obj.company_id = this.initialState.companyId
   }


   
   this.store$.dispatch(new storyActions.Update(this.initialState?.storyId, obj))

   this.onClose.emit(true)
  }

  savealias(){
    let obj:any = {}
    obj={
      author_alias:this.userForm.controls.author_alias.value,
      title_alias: this.userForm.controls.title.value,
      photo_alias:this.userForm.controls.avatarImage.value,
      // company_name_alias: this.userForm.controls.companyname.value
  }

  obj.created_by={
    id_user:this.author_id,
    show_name_public:this.userForm.controls.show_name_public.value,
    show_title_public:this.userForm.controls.show_title_public.value,
    show_company_public:this.userForm.controls.show_company_public.value,
    show_relationship_public:this.userForm.controls.show_relationship_public.value,
    is_alias:this.userForm.controls.is_alias.value,
  }

     if(this.userForm.controls.selctedId.value){
      obj.questionnaire = {0: this.userForm.controls.selctedId.value.toString()}
     }
     else if(!this.userForm.controls.selctedId.value){
      obj.questionnaire = {0: ''}
     }
     obj.show_prompt = this.userForm.controls.show_prompt.value ? 1 : 0
     obj.company_id = this.initialState.companyId
 
 
    
    this.store$.dispatch(new storyActions.Update(this.initialState?.storyId, obj))
 
    this.onClose.emit(obj)
   }




  getAuthorRelationShip(){
   if((this.authorDataRelationShip && (this.authorDataRelationShip.toLowerCase() == this.copyForm.controls.Label.value.toLowerCase()))){
    this.showError = ''
    return true
   }

   if(this.nameOfData && this.nameOfData.length && this.copyForm.controls.Label.value && this.nameOfData.includes(this.copyForm.controls.Label.value.toLowerCase())){
    this.showError = 'Prompt already exist please select from drop down'
    return true;
   }

   return false;

    
  }

  savelabel(){
    let request: UpdateTestimonialAudienceSettingInputApiModel;
    request = {
      name: this.copyForm.value.Label
    }
    this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Add(this.initialState.companyId, request));
  }

  saveUserlabel(){
    let request: UpdateTestimonialAudienceSettingInputApiModel;
    request = {
      name: this.userForm.value.Label
    }
    this.store$.dispatch(new adminStoryActions.testimonialAudienceSettingActions.Add(this.initialState.companyId, request));
  }




  
  async getBase64ImageFromUrl(imageUrl) {
    var res = await fetch(imageUrl);
    var blob = await res.blob();

    return new Promise((resolve, reject) => {
      var reader = new FileReader();
      reader.addEventListener("load", function () {
        resolve(reader.result);
      }, false);

      reader.onerror = () => {
        return reject(this);
      };
      reader.readAsDataURL(blob);
    })
  }

  changeRelationPublic(data){
    if(!this.copyForm.controls.show_relationship_public.value){
      this.copyForm.controls.Label.disable();
    }else{
      this.copyForm.controls.Label.enable();
    }
  }

  isValidUrlRegex(url: string): boolean {
    const pattern = /^(https?:\/\/)?([\w-]+(\.[\w-]+)+)(\/[\w-]*)*(\?.*)?(#.*)?$/;
    return pattern.test(url);
  }

  changeActionEvent(data){
    // if(!this.copyForm.controls.show_name_public.value){
    //   this.copyForm.controls.name.disable()
    // }
    // else{
    //   this.copyForm.controls.name.enable()
    // }
    if(!this.copyForm.controls.show_company_public.value){
      this.copyForm.controls.companyname.disable()
    }
    else{
      this.copyForm.controls.companyname.enable()
    }

    if(!this.copyForm.controls.show_title_public.value){
      this.copyForm.controls.title.disable()
    }
    else{
      this.copyForm.controls.title.enable()
    }
    if(!this.copyForm.controls.show_relationship_public.value){
      this.copyForm.controls.Label.disable();
    }else{
      this.copyForm.controls.Label.enable();
    }

    this.hideVisiblity = false;

  }



  public uploadData() {
    if(!this.isBrowser) return;

    const providerNode: any = document.querySelector("uc-upload-ctx-provider");
    const previewsNode = document.getElementById("previews");
    const config:any = document.querySelector("uc-config");

// Set custom error
if(config){
  config.localeDefinitionOverride = {
    en: {
      "files-max-size-limit-error":
        "File size too large! Please download and upload the file locally",
    },
  };
}


    if (!providerNode) return;

    this.apiCollection = providerNode.getAPI();
    
    providerNode.addEventListener('change', e => {
      console.log(e);
    });

    providerNode.addEventListener('file-added', e => {
      console.log(e);
    });

    providerNode.addEventListener('file-upload-failed', e => {
      const error = e.detail.errors[0];
      if (
        error.type === "UPLOAD_ERROR" &&
        error.message.includes("Downloaded file is too big")
      ) {
        // alert(
        //   "File size exceeds 300MB! Please download the file and upload it locally."
        // );
        // this.toastService.error("File size exceeds 300MB! Please download the file and upload it locally.")
      }
    });
    providerNode.addEventListener('file-upload-success', (e:any) => {
      if (!e.detail.fileInfo) return;

      setTimeout(()=>{
        const donebutton  = document.querySelector('.uc-done-btn') as HTMLElement;
        // const donateInner = donebutton.querySelector('button')
        if(donebutton){
          donebutton.click();
        }
  
      },300)

      if(e.detail.fileInfo.isImage) {
        // this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(true));
        // this.store$.dispatch(new mediaActions.GetExternalBlob(true));
        fetch(e.detail.fileInfo.cdnUrl)
        .then(response => response.blob())
         .then(blob => {
          // this.store$.dispatch(new mediaDownloadAction.CheckDownloaf(false));
          // this.store$.dispatch(new mediaActions.GetExternalBlob(false));
          const imageEditedBlob = blob;
          imageEditedBlob['path'] = 'story-image';
          this.uploader.addBlobs(imageEditedBlob);
         });
      } 
    });
  }

  public async uploadImage() {   
    if(!this.isBrowser) return;
  
    const uploader = document.querySelector('.uploader-hidden');
    if (uploader) {
      uploader.classList.remove('uploader-hidden');
    }
  
    const simpleBtn = document.querySelector('uc-simple-btn');
    if (!simpleBtn) return;
  
    if (this.apiCollection) {
      this.apiCollection.removeAllFiles();
    }
  
    const realButton = simpleBtn.querySelector('button');
    if (realButton) {
      realButton.click();
    }
  }

  /**
   * Open crop modal for avatar image editing
   * @param isInbound - whether this is for inbound form or user form
   */
  public openCropModal(isInbound: boolean = true) {
    const currentForm = isInbound ? this.copyForm : this.userForm;
    const currentImageUrl = currentForm.controls.avatarImage.value;
    
    if (!currentImageUrl) {
      this.toastService.error('Please upload an image first before cropping.');
      return;
    }

    // Configure cropper for circular avatar (1:1 aspect ratio)
    const cropperConfig: Partial<ImageCropperConfig> = {
      aspectRatio: NaN, // Force 1:1 aspect ratio for perfect circle
      viewMode: 1,
      dragMode: 'move',
      autoCropArea: 0.8,
      cropBoxResizable: true, // Fixed size crop box
      cropBoxMovable: true,
      center: true,
      highlight: true,
      background: true,
      modal: true,
      guides: true,
      responsive: true,
      checkCrossOrigin: true,
      checkOrientation: true,
      zoomable: true,
zoomOnWheel: true,
    movable: true,
    rotatable : true,
    scalable: true,
    };

    const initData: CropImageInitData = {
      imageUrl: currentImageUrl.split('?')[0],
      options: cropperConfig
    };

    this.modalService.showModal(CropImageModalComponent, initData, { class: 'modal-trans' }).then((croppedBlob: Blob) => {
      if (croppedBlob) {
        this.handleCroppedImage(croppedBlob, isInbound);
      }
    });
  }

  /**
   * Handle the cropped image result
   * @param croppedBlob - The cropped image blob
   * @param isInbound - whether this is for inbound form or user form
   */
  private handleCroppedImage(croppedBlob: Blob, isInbound: boolean) {
    // Clear any existing uploader errors since we have a valid image
    this.uploaderViewModel.isError = false;
    this.uploaderViewModel.errorMsg = '';
    
    // Create a temporary URL for immediate display
    const tempImageUrl = URL.createObjectURL(croppedBlob);
    const currentForm = isInbound ? this.copyForm : this.userForm;
    
    // Update the form with the temporary URL for immediate display
    currentForm.controls.avatarImage.setValue(tempImageUrl);
    
    // Create a file from the blob for upload
    const fileName = `cropped-avatar-${Date.now()}.png`;
    const croppedFile = new File([croppedBlob], fileName, { type: 'image/png' });
    
    // Add path property for uploader compatibility
    (croppedFile as any).path = 'story-image';
    
    // Upload the cropped image using the existing uploader
    this.uploader.addFiles([croppedFile]);
  }

  /**
   * Check if avatar image exists for cropping
   * @param isInbound - whether this is for inbound form or user form
   */
  public hasAvatarForCrop(isInbound: boolean = true): boolean {
    const currentForm = isInbound ? this.copyForm : this.userForm;
    return !!currentForm.controls.avatarImage.value;
  }

}
